import { useState } from "react";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import Link from "@amzn/meridian/link";
import exportLargeTokens from "@amzn/meridian-tokens/base/icon/export-large";
import documentTokens from "@amzn/meridian-tokens/base/icon/document";
import "./sourcesDropdown.scss";
import { DocumentInfo } from "./types";

interface SourcesDropdownProps {
  relatedDocuments: DocumentInfo[];
}

const SourcesDropdown = ({ relatedDocuments }: SourcesDropdownProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!relatedDocuments || relatedDocuments.length === 0) {
    return null;
  }

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <div className="sources-dropdown">
        <Button
          type="secondary"
          size="medium"
          onClick={toggleExpanded}
          className="sources-dropdown-toggle"
        >
          Sources
        </Button>

        {isExpanded && (
          <div className="sources-dropdown-content">
            <ul className="sources-list">
              {relatedDocuments.map((docInfo, index) => (
                <li key={index} className="source-item">
                  <Icon
                    className="icon"
                    tokens={documentTokens}
                    color="primary"
                  />
                  <Link
                    href={docInfo.url}
                    type="secondary"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {docInfo.title}
                    <Icon
                      className="icon"
                      tokens={exportLargeTokens}
                      color="primary"
                    />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </>
  );
};

export default SourcesDropdown;
